import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import {withRouter} from "react-router";
import {connect} from "react-redux";
import * as pagesActions from "../../actions/pages";
import * as pagesReducers from "../../reducers/pages";

//const history = createBrowserHistory();
class Login extends Component {
    constructor(props){
        super(props);
        this.state = {
            username: '',
            password: '',
            redirect: false,
            userDet : window.localStorage.userDet !=='undefined' && window.localStorage.userDet !==undefined ? JSON.parse(window.localStorage.userDet):undefined,

        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event) {

        this.setState({
            [event.target.name]: event.target.value
        });
    }

    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        console.log(this.props.loggedinData.loggedin+"-----"+prevProps.loggedinData.loggedin);
        if (this.props.loggedinData.loggedin !== prevProps.loggedinData.loggedin && this.props.loggedinData.loggedin === true) {
            window.localStorage.setItem('userDet', JSON.stringify(this.props.loggedinData.loggedUserData));
            console.log( window.localStorage.userDet);
            this.setState({ redirect: true });
        }
    }

    handleSubmit(event) {
        event.preventDefault();


        var userData = {username :this.state.username, password : this.state.password};
        console.log(userData);
        this.props.login(userData);
    }



    render() {

        if (this.state.redirect || this.state.userDet) {
            return <Redirect to='/overview'/>;
        }

        let logo = require("../../assets/images/logo-black.png");
        return (
            <div className="wrapper">
            <div className="login-wrapper">
                <div className="login-block">
                    <div className="login-brand-logo">
                        <img src={logo} alt="Vignets - Logo" />
                    </div>


                    <form
                        ref="form"
                        onSubmit = {this.handleSubmit}
                        onError={errors => console.log(errors)}>

                        <div className="login-input-block">
                            <input type="text" name="username" className="login-input-box" placeholder="Username" value={this.state.username} onChange={this.handleInputChange} required/>
                        </div>
                        <div className="login-input-block">
                            <input type="password" name="password" className="login-input-box" placeholder="Password" value={this.state.password}  onChange={this.handleInputChange} required />
                        </div>
                        <div className="button-block">
                            <button className="general-button login">Login</button>
                            <a href="javascript:void(0);" className="url-click">Forgot Password?</a>
                        </div>

                    </form>
                </div>
            </div>
            </div>

        );
    }
}
function mapStateToProps(state) {
    return {
        loggedinData  :pagesReducers.getPageSettings(state)
    };

}

export default  withRouter(connect(mapStateToProps, {
    login : pagesActions.checkLogin,
})(Login));


// WEBPACK FOOTER //
// ./src/components/login/Login.js